import React, { useState } from "react";
import * as XLSX from "xlsx-js-style";
import organizationService from "../../services/organizationService";
import { toast } from "react-toastify";
import countryService from "../../services/countryService";
import cityService from "../../services/cityService";

function OrganizationsReport() {
  const [showSpinning, setShowSpinning] = useState(false);

  const countryNames = {};
  const cityNames = {};

  const getCached = async (cache, service, id) => {
    if (!id) return "";
    if (!cache[id]) cache[id] = await service.getNameById(id);
    return cache[id];
  };

  const handleExport = async () => {
    try {
      setShowSpinning(true);
      const workbook = XLSX.utils.book_new();
      const headers = [
        "Organization Name",
        "Organization ID",
        "Email",
        "Phone Number",
        "Contact Name",
        "Registration Number",
        "APO Number",
        "Country",
        "City",
      ];

      // Collect all rows here
      const rows = [headers];
      const organizationsData = await organizationService.getAll();

      for (const organization of organizationsData) {
        const countryName = await getCached(
          countryNames,
          countryService,
          organization.country_id
        );
        const cityName = await getCached(
          cityNames,
          cityService,
          organization.city_id
        );

        rows.push([
          organization.name,
          organization.organization_id,
          organization.email,
          organization.phone_number,
          organization.contact_name,
          organization.registration_number,
          organization.APO_number,
          countryName,
          cityName,
        ]);
      }

      const worksheet = XLSX.utils.aoa_to_sheet(rows);
      worksheet["!cols"] = headers.map(() => ({ width: 60 }));
      worksheet["!rows"] = [{ hpx: 28 }];

      // Apply styles (headers and cells)
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let R = range.s.r; R <= range.e.r; ++R) {
        for (let C = range.s.c; C <= range.e.c; ++C) {
          const cell_address = XLSX.utils.encode_cell({ r: R, c: C });
          const cell = worksheet[cell_address];
          if (cell) {
            if (R === 0) {
              cell.s = {
                fill: { fgColor: { rgb: "CCFFCC" } },
                font: { bold: true, sz: 12 },
                alignment: { horizontal: "center", vertical: "center" },
              };
            } else {
              cell.s = {
                alignment: { horizontal: "center", vertical: "center" },
              };
            }
          }
        }
      }

      XLSX.utils.book_append_sheet(workbook, worksheet, "Organizations Report");
      XLSX.writeFile(workbook, "Organizations_Report.xlsx");
    } catch (error) {
      toast.error("Failed to generate TOV Report. Please try again.");
    } finally {
      setShowSpinning(false);
    }
  };

  return (
    <button
      data-track="export-organizations-report-button"
      data-module="Organizations"
      onClick={handleExport}
      className="bg-green-600 hover:bg-green-700 transition-colors duration-200 px-4 py-2  rounded-lg text-white font-medium flex gap-2 items-center"
    >
      <i className="fa-solid fa-file-arrow-down text-lg"></i>
      <span className="">Organizations Report</span>
      {showSpinning && (
        <svg
          className="animate-spin h-5 w-5 text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      )}
    </button>
  );
}

export default OrganizationsReport;
